import { createFileRoute } from '@tanstack/react-router';
import { AdminBeneficiariesPage } from '@/features/admin-beneficiaries';

export const Route = createFileRoute('/_authenticated/_admin/admin-beneficiaries')({
  component: AdminBeneficiariesPage,
});
